export default "__VITE_ASSET__DFMKD0Ek__"